var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileBg1Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237 110",
    style: {
      enableBackground: "new 0 0 237 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:5.000000e-02;}\n\t.st1{clip-path:url(#SVGID_00000174604235549496870200000002258201049603318975_);}\n\t.st2{fill:none;stroke:#F3F5FF;stroke-width:5;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M143.1,0h81.5c6.7,0,12.2,5.4,12.2,12v86c0,6.6-5.5,12-12.2,12h-81.5V0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032634203680150877820000002161327944180388760_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032634203680150877820000002161327944180388760_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.4,11c0,10.8-8.9,19.5-19.9,19.5s-19.9-8.7-19.9-19.5s8.9-19.5,19.9-19.5S185.4,0.2,185.4,11z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.7,104c0,10.8-8.9,19.5-19.9,19.5S160,114.8,160,104s8.9-19.5,19.9-19.5S199.7,93.2,199.7,104z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M268.9,80c0,15.2-12.5,27.5-28,27.5s-28-12.3-28-27.5c0-15.2,12.5-27.5,28-27.5S268.9,64.8,268.9,80z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.5,57c0,6.9-5.7,12.5-12.7,12.5s-12.7-5.6-12.7-12.5s5.7-12.5,12.7-12.5S192.5,50.1,192.5,57z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.2,4c0,6.9-5.7,12.5-12.7,12.5S204.8,10.9,204.8,4c0-6.9,5.7-12.5,12.7-12.5S230.2-2.9,230.2,4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.1,39c0,4.7-3.9,8.5-8.7,8.5c-4.8,0-8.7-3.8-8.7-8.5s3.9-8.5,8.7-8.5C218.2,30.5,222.1,34.3,222.1,39z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBg1Dark);
export default __webpack_public_path__ + "static/media/tile_bg_1-dark.b07ed250d15edc3cea95846a9217bb46.svg";
export { ForwardRef as ReactComponent };